export default __webpack_public_path__ + "static/2-e738f953cdb13997ca3c9f2c1c084610.jpg";